var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-controls"},[_c('button',{staticClass:"iamhere-btn loadmore-btn",attrs:{"disabled":_vm.isLoading},on:{"click":_vm.loadMore}},[_vm._v(" Load more lights ")]),_c('small',[_vm._v("Tap a light to explore")])])}
var staticRenderFns = []

export { render, staticRenderFns }